function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Balance-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.40369,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Energie-gebouwen-overzicht",
  transform: "translate(-250.000000, -192.000000)",
  stroke: "#000000",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "arrange-letter",
  transform: "translate(251.000000, 193.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.1875,9.68666667 L2.1875,0.311666667",
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "0.3125 7.81166667 2.1875 9.68666667 4.0625 7.81166667"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.02083333,9.68666667 L8.02083333,0.311666667",
  id: "Path",
  transform: "translate(8.020833, 4.999167) scale(1, -1) translate(-8.020833, -4.999167) "
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  transform: "translate(8.020833, 1.249167) scale(1, -1) translate(-8.020833, -1.249167) ",
  points: "6.14583333 0.311666667 8.02083333 2.18666667 9.89583333 0.311666667"
}))));
function SvgArrangeLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrange-letter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrangeLetter);
export default __webpack_public_path__ + "static/media/Arrange_letter.eeb8ae0ef6b77dec337c7e01fc8eb4c2.svg";
export { ForwardRef as ReactComponent };